import { useEffect, useState } from 'react';

export const useVisibilityTracker = () => {
  const [tabActive, setTabActive] = useState(true);

  const handleVisibilityChange = () => {
    if (document.hidden) {
      setTabActive(false);
    } else {
      setTabActive(true);
    }
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { tabActive };
};
